const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=warm%20cinematic%20scene%20with%20soft%20orange%20and%20gold%20lighting%2C%20abstract%20film%20atmosphere%2C%20artistic%20movie%20visual%20with%20gentle%20gradient%20background%2C%20clean%20minimal%20composition%2C%20no%20text%20no%20people&width=800&height=500&seq=card-01-2026&orientation=landscape',
    title: '热门电影 · 院线大片抢先看',
    desc: '汇聚国内外最新上映热门电影，高清画质流畅播放，足不出户尽享影院级观影体验。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=warm%20amber%20toned%20abstract%20drama%20visual%2C%20soft%20cinematic%20lighting%20with%20gentle%20warm%20gradient%2C%20artistic%20storytelling%20atmosphere%2C%20clean%20composition%2C%20no%20text%20no%20people&width=800&height=500&seq=card-02-2026&orientation=landscape',
    title: '热播电视剧 · 全集不缓冲',
    desc: '国产剧、韩剧、美剧、日剧一网打尽，实时追更新剧集，全集打包一次看个够。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=warm%20golden%20abstract%20entertainment%20visual%2C%20soft%20dramatic%20cinematic%20mood%2C%20artistic%20variety%20show%20atmosphere%20with%20warm%20lighting%2C%20clean%20minimal%20composition%2C%20no%20text%20no%20people&width=800&height=500&seq=card-03-2026&orientation=landscape',
    title: '综艺娱乐 · 欢乐不停歇',
    desc: '热门综艺、搞笑合集、真人秀节目随时随地想看就看，解压放松首选。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=nostalgic%20warm%20toned%20abstract%20classic%20film%20visual%2C%20soft%20vintage%20cinematic%20lighting%2C%20artistic%20retro%20movie%20atmosphere%2C%20gentle%20warm%20gradient%20background%2C%20no%20text%20no%20people&width=800&height=500&seq=card-04-2026&orientation=landscape',
    title: '经典老片 · 怀旧放映厅',
    desc: '重温那些年我们一起追过的经典电影，高清修复画质，情怀永不褪色。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=warm%20energetic%20abstract%20animation%20visual%2C%20soft%20colorful%20cinematic%20lighting%2C%20artistic%20animated%20film%20atmosphere%2C%20gentle%20warm%20gradient%20background%2C%20clean%20composition%2C%20no%20text%20no%20people&width=800&height=500&seq=card-05-2026&orientation=landscape',
    title: '动漫番剧 · 二次元盛宴',
    desc: '国漫崛起、日漫经典，热门新番同步更新，动漫爱好者不可错过的宝藏库。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            每日精选优质影视内容，热门好片不容错过
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.slice(0, 3).map((card, i) => (
            <article key={i} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer">
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {cards.slice(3, 5).map((card, i) => (
            <article key={i + 3} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer flex flex-col sm:flex-row">
              <div className="relative sm:w-2/5 aspect-[16/10] sm:aspect-auto overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 sm:w-3/5 flex flex-col justify-center">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}